import { MembershipPlansProps } from "modules/membership_plan/commercial_membership_plan/commercial_membership/store/actionType";

export enum actionTypes {
  //fetch email
  FETCH_EMAIL_LOGS_REQUEST = "FETCH_EMAIL_LOGS_REQUEST",
  FETCH_EMAIL_LOGS_SUCCESS = "FETCH_EMAIL_LOGS_SUCCESS",
  FETCH_EMAIL_LOGS_FAIL = "FETCH_EMAIL_LOGS_FAIL",
  //create coupon
  SEND_EMAIL_REQUEST = "SEND_EMAIL_REQUEST",
  SEND_EMAIL_SUCCESS = "SEND_EMAIL_SUCCESS",
  SEND_EMAIL_FAIL = "SEND_EMAIL_FAIL",
  RESET_EMAIL = "RESET_EMAIL",
}

export enum stateStatusType {
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
}

export interface EmailLogProps {
  content:string;
  created_at:string;
  error_message:string;
  id:string;
  receiver:string;
  status:string;
  subject:string;
  title:string;
  updated_at:string;
}

export interface MailInput {
  to: string;
  subject: string;
  title: string;
  content: string;
}

//fetch email
export interface FetchEmailLogsRequestAction {
  type: actionTypes.FETCH_EMAIL_LOGS_REQUEST;
}

export interface FetchEmailLogsSuccessAction {
  type: actionTypes.FETCH_EMAIL_LOGS_SUCCESS;
  payload: EmailLogProps[];
}

export interface FetchEmailLogsFailAction {
  type: actionTypes.FETCH_EMAIL_LOGS_FAIL;
  payload: string;
}

//create coupon
export interface SendEmailRequestAction {
  type: actionTypes.SEND_EMAIL_REQUEST;
}

export interface SendEmailSuccessAction {
  type: actionTypes.SEND_EMAIL_SUCCESS;
  payload: string;
}

export interface SendEmailFailAction {
  type: actionTypes.SEND_EMAIL_FAIL;
  payload: string;
}
export interface ResetCoupon {
  type: actionTypes.RESET_EMAIL;
}

export interface ResetCoupon {
  type: actionTypes.RESET_EMAIL;
}

export type CouponsActions =
  | FetchEmailLogsRequestAction
  | FetchEmailLogsSuccessAction
  | FetchEmailLogsFailAction
  | SendEmailRequestAction
  | SendEmailSuccessAction
  | SendEmailFailAction
  | ResetCoupon;
